import mutations from './mutations';
import { state } from './state';

const registrationData = {
  mutations,
  state,
};

export default registrationData;
